import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Typography,
  IconButton,
  TextField,
  Checkbox,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import { GET_COUNTRIES, GET_STATES, GET_CITY } from "../../../Utils/Queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import Loader from "../../../Components/Common/Loader";
import { useSelector } from "react-redux";
import { ADD_ADDRESS } from "../../../Utils/Mutations";
import { useSnackbar } from "notistack";
import MaSearchableSelect from "../../../Components/UI/ma-dropdown";
import MaButton from "../../../Components/UI/ma-button";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 400, md: 400, sm: 320, xs: 310 },
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2.5,
  borderRadius: "16px",
};

const AddAddress = ({
  action,
  open: controlledOpen,
  onClose,
  hideTrigger = false,
}) => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const handleOpen = () => {
    if (isControlled) return;
    setInternalOpen(true);
  };

  const handleClose = () => {
    if (isControlled) {
      onClose?.();
      return;
    }
    setInternalOpen(false);
  };

  const [selectedCountry, setSelectedCountry] = useState("");

  const [stateID, setStateID] = useState("");

  const [cityID, setCityID] = useState("");

  const [selectedState, setSelectedState] = useState("");

  const [zip, setZip] = useState("");

  const [phoneNo, setPhoneNo] = useState();

  const [selectedCity, setSelectedCity] = useState("");

  const [countryID, setCountryID] = useState(null);

  const [address, setAddress] = useState("");

  // ========QUERIES===========================================================================================================================
  const [getCountries, { loading, error, data }] = useLazyQuery(GET_COUNTRIES);
  const [getState, { loading: stateLoad, error: statError, data: stateData }] =
    useLazyQuery(GET_STATES);
  const [getCity, { loading: cityLoad, error: cityError, data: cityData }] =
    useLazyQuery(GET_CITY);

  const { firstName, lastName, phone } = useSelector(
    (state) => state.user?.user.profile,
  );

  // ======ALERT FNC =================================================================================================
  const { enqueueSnackbar } = useSnackbar();
  const handleAlert = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [checked, setChecked] = React.useState(false);

  const handleChange2 = (value) => {
    setSelectedCountry(value);
    setCountryID(value);
    setSelectedState("");
    setSelectedCity("");
  };
  const handleChange = (value) => {
    setSelectedState(value);
    setStateID(value);
    setSelectedCity("");
  };
  const handleChange3 = (value) => {
    setSelectedCity(value);
    setCityID(value);
  };

  const handleChecked = (event) => {
    setChecked(event.target.checked);
  };

  // =======GET COUNTRIES , STATE, CITY===============================================================================================

  useEffect(() => {
    getCountries();
    getState({
      variables: {
        country: countryID,
      },
    });
    getCity({
      variables: {
        state: stateID,
      },
    });
  }, [countryID, stateID]);

  // ADD ADDRESS MUTATION ===============================================================================================================

  const [addAddress, { loading: addLoading }] = useMutation(ADD_ADDRESS);

  const handleAddAddress = async () => {
    handleClose();
    await addAddress({
      variables: {
        firstName,
        lastName,
        country: countryID,
        state: stateID,
        city: cityID,
        addressOne: address,
        addressTwo: "",
        zipCode: zip,
        phone: phone ? phone : phoneNo,
        isDefault: checked,
      },
    })
      .then((response) => {
        action();

        handleAlert(`Address added successfully`, "success");
      })
      .catch((err) => {
        handleAlert(`${err.message}`, "error");
      });
  };

  const countriesOptions =
    data?.getAllCountries?.items?.map((country) => ({
      label: country?.name,
      value: country?._id,
    })) || [];
  const stateOptions =
    stateData?.fetchStates?.items?.map((state) => ({
      label: state.name,
      value: state._id,
    })) || [];

  const cityOptions = cityData?.fetchCities?.items?.map((city) => ({
    label: city?.name,
    value: city?._id,
  }));

  return (
    <>
      {addLoading && <Loader />}
      {loading && <Loader />}
      {!hideTrigger ? (
        <Button
          variant="contained"
          sx={{ borderRadius: "24px" }}
          onClick={handleOpen}
        >
          Add Address
        </Button>
      ) : null}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <h3 className="font-bold text-black my-0 text-[18px] ">
                Add Address
              </h3>
              <span className="leading-[10px] text-[12px] text-[#333]">
                Shipping address will be used at checkout{" "}
              </span>
            </div>
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ color: "#333" }} />
            </IconButton>
          </Box>
          <Box sx={{ mt: 3 }}>
            <label className="text-[#4d4d4d] text-[14px] font-medium pb-3 ">
              {" "}
              Address
            </label>

            <TextField
              fullWidth
              placeholder="Apartment, suite, unit, building, floor, etc."
              margin="dense"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              InputProps={{
                style: {
                  fontSize: "13px",
                  borderRadius: "8px",
                  offset: " 1px solid #f2f2f2",
                },
              }}
            />
            {phone ? (
              ""
            ) : (
              <>
                <Typography
                  sx={{ color: "#4d4d4d", fontSize: "14px", fontWeight: 500 }}
                >
                  {" "}
                  Phone Number
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Phone"
                  margin="normal"
                  value={phoneNo}
                  onChange={(e) => {
                    // Remove non-digit characters, including spaces
                    const digitsOnly = e.target.value.replace(/\D/g, "");
                    // Limit to 11 digits
                    if (digitsOnly.length <= 10) {
                      setPhoneNo(digitsOnly);
                    }
                  }}
                  inputProps={{
                    inputMode: "numeric", // improves UX on mobile
                    maxLength: 11, // limits physical typing
                    pattern: "[0-9]*", // optional: for some mobile browsers
                  }}
                  InputProps={{
                    style: {
                      fontSize: "13px",
                      borderRadius: "8px",
                      offset: " 1px solid #f2f2f2",
                    },
                  }}
                />
              </>
            )}
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <MaSearchableSelect
                  options={countriesOptions}
                  value={selectedCountry}
                  onChange={handleChange2}
                  placeholder={loading ? "Loading..." : "Country"}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <MaSearchableSelect
                  options={stateOptions}
                  value={selectedState}
                  onChange={handleChange}
                  placeholder={stateLoad ? "Loading..." : "Select State"}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <MaSearchableSelect
                  options={cityOptions}
                  value={selectedCity}
                  onChange={handleChange3}
                  placeholder={cityLoad ? "City Loading" : "City"}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextField
                  type="number"
                  fullWidth
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                  placeholder="Zip code"
                  InputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: {
                      mt: 1.5,
                      fontSize: "13px",
                      borderRadius: "8px",
                      offset: " 1px solid #f2f2f2",
                      // Replace with your desired font family
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Divider sx={{ mt: 2 }} />
            <Box sx={{ mt: 2 }}>
              <div className="flex items-center gap-x-2">
                <Checkbox checked={checked} onChange={handleChecked} />
                <div className="flex flex-col">
                  <label className="text-[13px] font-medium">
                    Set as default shipping address
                  </label>
                  <label className="text-[12px]">
                    This address will be automatically selected for your next
                    orders.
                  </label>
                </div>
              </div>
              <div className="flex items-center gap-x-4 mt-10">
                <div className="flex-1">
                  <MaButton variant={"outlined"} title="Cancel" fullWidth />
                </div>
                <div className="flex-1">
                  <MaButton
                    fullWidth
                    variant={"primary"}
                    disabled={!selectedCity || !zip}
                    onClick={handleAddAddress}
                    title="Save address"
                  />
                </div>
              </div>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AddAddress;
